import React from 'react';
import {Link} from 'react-router-dom';
import {twMerge} from 'tailwind-merge';

interface Props {}

export const NotFound: React.FC<Props> = () => {
    return (
        <div className="flex h-full w-full flex-col items-center justify-center gap-4">
            <h1
                className={twMerge(
                    "color-black relative flex gap-5 font-['Inter'] text-[clamp(1rem,6vw,4rem)] font-black"
                )}
            >
                Not
                <span className="bg-gradient-to-r from-[#00E0FF] to-[#FF9A9A] bg-clip-text text-transparent">
                    Found
                </span>
            </h1>
            <Link
                to="/manage"
                className="rounded-lg border border-neutral-800 px-4 py-2 text-sm font-medium uppercase text-neutral-800 hover:bg-neutral-300"
            >
                Return to safety
            </Link>
        </div>
    );
};
